import { z } from 'zod'

import {
  createWebComponentPropertyDescriptor,
  webComponentAttributeParsers,
} from '@salsita-ai/platform-project-sdk/domain'
import { useWebComponentPropertyValue } from '@salsita-ai/platform-project-sdk/react'

/**
 * Liquid will provide an empty string instead of undefined if no customer email is set.
 */
const emailOrEmptySchema = z.union([z.string().email(), z.literal('')])
const pixelSizeSchema = z.number().positive()

export const webComponentProperties = {
  customerEmail: createWebComponentPropertyDescriptor({
    schema: emailOrEmptySchema,
    attributeParser: webComponentAttributeParsers.string,
    attributeNames: ['customeremail', 'customer-email'],
    defaultValue: undefined,
  }),
  customerTags: createWebComponentPropertyDescriptor({
    schema: z.array(z.string()),
    attributeParser: webComponentAttributeParsers.commaSeparatedStrings,
    attributeNames: ['customertags', 'customer-tags'],
    defaultValue: [] as string[],
  }),
  configuratorMinBlockSize: createWebComponentPropertyDescriptor({
    schema: pixelSizeSchema,
    attributeParser: webComponentAttributeParsers.number,
    attributeNames: ['configuratorminblocksize', 'configurator-min-block-size'],
    defaultValue: 650,
  }),
}

export const useCustomerProperties = () => {
  const customerEmail = useWebComponentPropertyValue(webComponentProperties.customerEmail)
  const customerTags = useWebComponentPropertyValue(webComponentProperties.customerTags)

  return {
    customerEmail,
    customerTags,
  }
}

export const useConfiguratorMinBlockSize = () =>
  useWebComponentPropertyValue(webComponentProperties.configuratorMinBlockSize)
